import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
const TermsOfServicePageMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "mobile" */ "~/components/mobile/pages/TermsOfServiceApp"
    ),
  loading: LoadableLoading
});
const TermsOfServicePageDesktop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "desktop" */ "~/components/mobile/pages/TermsOfServiceApp"
    ),
  loading: LoadableLoading
});

class DetectTermsOfService extends Component {
  render() {
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <TermsOfServicePageMobile />
        ) : (
          <TermsOfServicePageDesktop />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    }
  } = state;
  return {
    device: type
  };
};

const TermsOfServiceHelmet = withTitle({
  component: DetectTermsOfService,
  title: "Medpro | Điều khoản dịch vụ"
});

export default connect(mapStateToProps)(TermsOfServiceHelmet);
